import React from "react";
import { styles } from "../styles";

// Create styles

// Create Document Component
export const DistributionDocHTML = (props) => {
  return (
    <div style={{ width: "500px", border: "5px", background: "white" }}>
      {props.title && (
        <div style={styles.pageHeaderText}>Distribution Chain</div>
      )}
      {props.notSM && (
        <div style={styles.section}>
          <div style={styles.headerText}>SOLD TO</div>
          {props.salesData &&
            props.salesData.map((sale) => (
              <div style={styles.text}>{sale}</div>
            ))}
        </div>
      )}
      <div style={styles.section}>
        {props.notSM && (
          <>
            <div style={styles.headerText}>FINAL INFUSED PRODUCT</div>
            <div style={styles.text}>
              <div style={styles.subHeaderText}>Product Manufactured by: </div>
              {props.mfr}
            </div>
            {props.dstr && (
              <div style={styles.text}>
                <div style={styles.subHeaderText}>Product Distributed by: </div>
                {props.dstr}
              </div>
            )}
            <div style={styles.text}>
              <div style={styles.subHeaderText}>Licensed and Sold By: </div>
              {props.licHldr}
            </div>
            <div style={styles.text}>
              <div style={styles.subHeaderText}>
                Marijuana Establishment License #:{" "}
              </div>
              {props.license}
            </div>
            <div style={styles.text}>
              <div style={styles.subHeaderText}>Batch ID: </div>
              {props.batchId}
            </div>
            <div style={styles.text}>
              <div style={styles.subHeaderText}>Date of Manufacture: </div>
              {new Date(props.mfrDate).toLocaleDateString("en-US") === "Invalid Date"
                ? props.mfrDate
                : new Date(props.mfrDate).toLocaleDateString("en-US")}
            </div>
          </>
        )}
        <div style={styles.subSection}>
          {props.data.map((sourceMed) => (
            <>
              <div style={styles.headerText}>SOURCE EXTRACT</div>
              <div style={styles.text}>
                <div style={styles.subHeaderText}>License Holder Name: </div>
                {sourceMed.licenseName}
              </div>
              <div style={styles.text}>
                <div style={styles.subHeaderText}>
                  Marijuana Establishment License #:{" "}
                </div>
                {sourceMed.MEL}
              </div>
              {/* <div style={styles.text}>
                <div style={styles.subHeaderText}>
                  Marijuana Establishment Address:{" "}
                </div>
                {sourceMed.address[0]}
              </div> */}
              <div style={styles.text}>
                <div style={styles.subHeaderText}>Manufactured by: </div>
                {sourceMed.mfrBy}
              </div>
              <div style={styles.text}>
                <div style={styles.subHeaderText}>Batch ID: </div>
                {sourceMed.sourceMedBatch}
              </div>
              <div style={styles.text}>
                <div style={styles.subHeaderText}>Date of Manufacture: </div>
                {new Date(sourceMed.mfrDate).toLocaleDateString("en-US")}
              </div>
              <div style={styles.subSection}>
                {sourceMed.cultivators.map((cultivator) => (
                  <>
                    <div style={styles.headerText}>CULTIVATED MATERIAL</div>
                    <div style={styles.text}>
                      <div style={styles.subHeaderText}>
                        License Holder Name:{" "}
                      </div>
                      {cultivator.licenseName}
                    </div>
                    <div style={styles.text}>
                      <div style={styles.subHeaderText}>
                        Marijuana Establishment License #:{" "}
                      </div>
                      {cultivator.MEL}
                    </div>
                    {/* <div style={styles.text}>
                      <div style={styles.subHeaderText}>
                        Marijuana Establishment Address:{" "}
                      </div>
                      {cultivator.cultivatorAddress}
                    </div> */}
                    <div style={styles.text}>
                      <div style={styles.subHeaderText}>Harvested By: </div>
                      {cultivator.harvestedBy}
                    </div>
                    <div style={styles.subSection}>
                      {cultivator.batches.map((batch) => (
                        <di>
                          <div style={styles.text}>
                            <div style={styles.subHeaderText}>Batch ID: </div>
                            {batch.batchId}
                          </div>
                          <div style={styles.subSection}>
                            <div style={styles.text}>
                              <div style={styles.subHeaderText}>
                                Harvest Date:{" "}
                              </div>
                              {batch.harvestDate}
                            </div>
                            {/* <div style={styles.text}>
                              <div style={styles.subHeaderText}>
                                Harvest Address:{" "}
                              </div>
                              {batch.harvestAddress}
                            </div> */}
                          </div>
                        </di>
                      ))}
                    </div>
                  </>
                ))}
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
};
